import { MetaData } from "../types";
import { z } from "zod";

export interface CustomerDataToUpdate {
  customer_id: number;
  comment?: string;
  first_name?: string;
  last_name?: string;
  description?: string;
  phone: string;
  metadata?: MetaData[];
  metaDataToDelete?: string[];
}

// Схема для валидации метаданных
export const MetaDataSchema = z.object({
  key: z.string(),
  value: z.string().optional(),
});

// Схема для валидации тела запроса
export const CustomerDataToUpdateSchema = z.object({
  first_name: z.string().min(1, "Имя обязательно"),
  last_name: z.string().optional(),
  phone: z.string().min(1, "Телефон обязателен"),
  description: z.string().optional(), // УБЕДИТЕСЬ, ЧТО ТАК
  comment: z.string().optional(),
  source_id: z.string().optional(),
  metadata: z.array(
    z.object({
      key: z.string().min(1, "Ключ обязателен"),
      value: z.string().min(1, "Значение обязательно"),
    })
  ).optional(),
});

export type UpdateUserCustomerType = z.infer<typeof CustomerDataToUpdateSchema>;
